import React from 'react';
import styles from './ProgressBar.module.scss';

export const ProgressBarComponent = ({ percent = 0, color = 'blue-500' }) => {
  const clampedPercent = Math.min(100, Math.max(0, percent));

  return (
    <div className={styles.track}>
      <div
        className={styles.fill}
        style={{
          width: `${clampedPercent}%`,
          background: `var(--${color})`,
        }}
      />
    </div>
  );
};

ProgressBarComponent.displayName = 'ProgressBar';
